import { createAction } from "@reduxjs/toolkit";
import type { UserDetailVM } from "@shared-kernel/application/ports/admin/admin-repository";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const retrieveUser = createApiThunk<UserDetailVM, string>(
  "users/retrieveUser",
  async (id: string, { extra: { adminRepository } }) => {
    return adminRepository!.getUser(id);
  },
);

export const resetRetrieveUser = createAction("users/resetRetrieveUser");
